import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="flex items-center gap-3 text-slate-500">
        <span className="w-5 h-5 flex items-center justify-center animate-spin">
          <i className="ri-loader-4-line" />
        </span>
        <span className="text-sm">正在跳转...</span>
      </div>
    </div>
  );
}